import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Widget, WidgetType, WidgetLocation } from "@models/widget";
import {
  deleteRequest,
  fetchRequest,
  updateOrderRequest
} from "@actions/widget";
import WidgetsTable from "@components/widgets/Table";
import TableRenderer from "@hocs/TableRenderer";
import { getWidgetsList } from "@reducers/widget";
import { Button, Card, Col, Row, Menu, Icon } from "antd";
import { FormattedMessage } from "react-intl";
import { Dropdown } from "antd";
import SearchWidgetsComponent from "@components/widgets/Search";
import {NavLink} from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: Widget[];
  errors?: string;
  count: number;
  updateOrderRequest: any;
  defaultPageFilter: WidgetLocation.HOME_PAGE;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
  updateOrderRequest: typeof updateOrderRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class WidgetsIndexPage extends React.Component<AllProps> {
  deleteWidget = (item: Widget): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const {
      loading,
      data,
      search,
      currentPage,
      updateOrderRequest
    } = this.props;
    const menu = (
      <Menu>
        {Object.values(WidgetType).map( (type, index) => (
          (type !== 'continue_watching' && type !== 'android_channel') && <Menu.Item key={index}>
            <NavLink to={`/widgets/create/${type}`}>
             <span>
                <FormattedMessage
                  id={`app.${type}`}
                />
              </span>
            </NavLink>
          </Menu.Item>
        ))}
      </Menu>
    );
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <Dropdown trigger={["click"]} overlay={menu}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_widget"
                defaultMessage={`Create Widget`}
              />
              <Icon type="down" />
            </Button>
          </Dropdown>
        </div>
        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchWidgetsComponent search={search} />
          </Card>
          <WidgetsTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteWidget}
            loading={loading}
            updateOrderRequest={updateOrderRequest}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ widgets }: ApplicationState) => {
  return {
    loading: widgets.loading,
    data: getWidgetsList(widgets),
    count: widgets.count,
    defaultPageFilter: { widget_location: WidgetLocation.HOME_PAGE }
  };
};

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest,
  updateOrderRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(WidgetsIndexPage));
